export default "__VITE_ASSET__C6EaLTQ8__"